var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg-sprite-4517b925566e061f1603b3f020ad82d5.svg#icon-hamburger-62918';
                    var viewUrl = 'svg-sprite-4517b925566e061f1603b3f020ad82d5.svg#view-icon-hamburger-62918';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: 'undefined',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };